import dayjs from "dayjs";

// Move the interfaces and default values here from FiltersSidebar.tsx

export interface ImageFilter {
  checked: boolean;
  imageCount: number;
  operator: string;
}

export interface AssetFilters {
  asset_id?: string;
  start_date?: string;
  end_date?: string;
  croppedImages: ImageFilter;
  configuration?: string;
  bgrImages: ImageFilter;
  exteriorImages: ImageFilter;
  featuredImages: ImageFilter;
  manualImages: ImageFilter;
  panoramicImages: ImageFilter;
  ucImages: ImageFilter;
  pushed?: boolean | null;
  syndicated?: boolean | null;
  processingStatus: string;
  syndicationStatus: string;
  archived: boolean;
}

export const defaultImageFilterValue: ImageFilter = {
  checked: false,
  imageCount: 0,
  operator: '=',
};

export const getDefaultAssetDateRange = () => ({
  start_date: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
  end_date: dayjs().format("YYYY-MM-DD"),
});

export const defaultFilters: AssetFilters = {
  asset_id: undefined,
  ...getDefaultAssetDateRange(),
  croppedImages: defaultImageFilterValue,
  configuration: undefined,
  bgrImages: defaultImageFilterValue,
  exteriorImages: defaultImageFilterValue,
  featuredImages: defaultImageFilterValue,
  manualImages: defaultImageFilterValue,
  panoramicImages: defaultImageFilterValue,
  ucImages: defaultImageFilterValue,
  pushed: null,
  syndicated: null,
  processingStatus: "any",
  syndicationStatus: "any",
  archived: false,
};

const isDefaultImageFilter = (filter?: ImageFilter) => {
  return (
    !filter?.checked &&
    (filter?.imageCount ?? 0) === 0 &&
    (filter?.operator || '=') === '='
  );
};

export const hasActiveAssetFilters = (filters: AssetFilters): boolean => {
  const defaultDates = getDefaultAssetDateRange();

  if (filters.asset_id) return true;
  if ((filters.start_date || defaultDates.start_date) !== defaultDates.start_date) return true;
  if ((filters.end_date || defaultDates.end_date) !== defaultDates.end_date) return true;
  if (filters.configuration) return true;
  if (filters.processingStatus !== defaultFilters.processingStatus) return true;
  if (filters.syndicationStatus !== defaultFilters.syndicationStatus) return true;
  if (filters.archived) return true;

  return [
    filters.croppedImages,
    filters.bgrImages,
    filters.exteriorImages,
    filters.featuredImages,
    filters.manualImages,
    filters.panoramicImages,
    filters.ucImages,
  ].some((filter) => !isDefaultImageFilter(filter));
};
